export default {
  html: document.querySelectorAll("html"),
  form: document.querySelector(".search-form"),
  input: document.querySelectorAll(".search-input"),
  gallery: document.querySelector(".photo-gallery-list"),
  switcher: document.querySelector(".languages"),
  enBtn: document.querySelector(".lang-en"),
  ruBtn: document.querySelector(".lang-ru"),
  homeBtn: document.querySelector(".home-button"),
  libraryBtn: document.querySelector(".library-button"),
  watchedBtn: document.querySelector(".watched-button"),
  queueBtn: document.querySelector(".queue-button"),
  copyright: document.querySelector(".footer-copyright"),
  developed: document.querySelector(".footer-developed-text"),
  by: document.querySelector(".by-text"),
  byStudents: document.querySelector(".footer-developed-students"),
  libraryBtn: document.querySelector(".library-button"),
  homeBtn: document.querySelector(".home-button"),
  header: document.querySelector(".header"),
  search: document.querySelector(".search"),
  buttons: document.querySelector(".header-buttons"),
  paginator: document.querySelector(".paginator"),
};
